module.exports = __webpack_public_path__ + "static/media/Balancing_Tube_0_2ml_ST.47b739e1.svg";